import React from "react";
import { useState } from "react";
import { Image, Platform, View } from "react-native";
import FastImage, { Source } from "@d11/react-native-fast-image";
import SimpleCenteredSpinner from "../SimpleCenteredSpinner/SimpleCenteredSpinner";
import { useInteractionsManager } from "../API/Context-API/hooks/useInteractionsManager";

const imageAspectRatioCache = new Map<string, number>();

interface AutoWidthImage {
    source: Source
    scaleAll: number, 
    height: number,
    maxWidth?: number,
    onLoad?: () => any
}
export const AutoWidthImage:React.FC<AutoWidthImage> = ({ source, scaleAll, height, onLoad, maxWidth}) => {
    const [aspectRatio, setAspectRatio] = useState(
        source.uri ? imageAspectRatioCache.get(source.uri) ?? 0 : 0
    );
    const [sizeResolveFailed, setSizeResolveFailed] = useState(false);

    useInteractionsManager({
        func: () => {
        if (source.uri) {
            // console.log('source.uri', source.uri)
            if(!aspectRatio){
                Image.getSize(
                    source.uri,
                    (width, height) => {
                        const nextAspectRatio = width / height;
                        imageAspectRatioCache.set(source.uri as string, nextAspectRatio);
                        setAspectRatio(nextAspectRatio);
                        setSizeResolveFailed(false);
                    },
                    () => {
                        setSizeResolveFailed(true);
                    }
                );
            }
            
        }
    },deps: [source]});


    const [loaded, setLoaded] = useState(false)
    return (
        (aspectRatio > 0 || sizeResolveFailed) ? 
        <FastImage
            source={source}
            resizeMode='contain'
            
            style={[{
                height: height,
                ...(aspectRatio > 0 ? { aspectRatio } : { width: "100%" }),
                
                ...(Platform.OS === 'web' && {
                    imageRendering: 'high-quality',
                  }),
            }, maxWidth && {maxWidth}]}
            onLoad = {() => {
                setLoaded(true)
                if(onLoad)
                    onLoad()
            }}
        /> : 
        <View style = {{height: height}}>
            <SimpleCenteredSpinner height={20 * scaleAll} width={20 * scaleAll}/>
        </View>
    );
};

interface AutoHeighImage {
    source: Source
    scaleAll: number, 
    width: number
    maxHeight?: number | undefined
}

export const AutoHeighImage:React.FC<AutoHeighImage> = ({maxHeight, source, scaleAll, width}) => {
    const [aspectRatio, setAspectRatio] = useState(
        source.uri ? imageAspectRatioCache.get(source.uri) ?? 0 : 0
    );

    useInteractionsManager({
        func: () => {
        if (source.uri) {
            
            if(!aspectRatio){
                Image.getSize(source.uri, (width, height) => {
                    const nextAspectRatio = width / height;
                    imageAspectRatioCache.set(source.uri as string, nextAspectRatio);
                    setAspectRatio(nextAspectRatio);
                });
            }
        }
    }, deps: [source]});

    return (
        aspectRatio > 0 ? <FastImage
            source={source}
            resizeMode='contain'
            style={{
                width: width,
                maxHeight: maxHeight,
                aspectRatio,
                ...(Platform.OS === 'web' && {
                                                        imageRendering: 'high-quality',
                                                      }),
            }}
        /> : 
        <View style = {{width: width, height: width, maxHeight: maxHeight}}>
            <SimpleCenteredSpinner height={20 * scaleAll} width={20 * scaleAll}/>
        </View>
    );
};
